import { css } from '@fable/theme'

export const FlowerLeaves = () => {
  return (
    <svg
      className={css`
        width: 100%;
      `}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 55.45 29.8"
    >
      <path
        d="m26.85,18.8c-.02,1.11-.98,1.63-1.73.81L1.37.2C.82-.25,0,.12,0,.83c.02,4.19.86,7.07,2.7,10.93,4.16,8.71,11.41,8.83,21.32,10.58,1.84.32,3.15,1.97,3.13,3.84,0,.23-.08.44-.21.61-.2.27-.43.55-.44.88-.02.49-.02.98.04,1.46.05.38.37.64.75.66.25.01.5.02.75.02.23,0,.47,0,.7,0,.22,0,.44,0,.65-.01.51-.01.88-.47.87-.97-.01-.53.02-1.05.07-1.58h0s0,0,0,0c-.08,0-.15.01-.23.02-.59.03-1.08-.46-1.07-1.05v-.19c.01-1.15.55-2.18,1.38-2.87.5-.42,1.12-.71,1.8-.84,9.93-1.84,17.71-1.42,21.77-10.22,1.71-3.7,1.5-6.26,1.42-9.29-.02-.72-.86-1.13-1.43-.69l-22.65,17.35s-.08.07-.12.11c-.75.76-1.7.21-1.68-.89"
        fill="#4f8011"
      />
    </svg>
  )
}
